import { useState } from 'react';
import { apiClient } from '../utils/apiClient';
import { API_CONFIG } from '../config/apiConfig';

export const useSubmitRequest = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitRequest = async (returnHeaderId: string, userId: string, respId: string) => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.post(API_CONFIG.ENDPOINTS.SUBMIT_REQUEST, {
        p_return_header_id: returnHeaderId,
        p_user_id: userId,
        p_resp_id: respId
      });

      if (!response.data.success) {
        throw new Error(response.data.error || 'Failed to submit request');
      }

      return response.data;
    } catch (err: any) {
      const errorMessage = err.message || 'Failed to submit request';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    submitRequest,
    loading,
    error
  };
};